import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { ServerURLService } from 'src/app/common-service/serverURL.service';
import { PtrService } from '../ptr-service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { encryptionService } from '../../../app/common-service/cedService';
import { ToastrService } from 'ngx-toastr';
import { HelperService } from 'src/app/common-service/helper.service';
import * as moment from 'moment';
import { UsrmgtService } from 'src/app/usermgt/services/usrmgt.service';
import { EncrDecrService } from 'src/app/common-service/EncrDecrService';
import { ExcutiveService } from 'src/app/excucomm/service/excutive.service';
import { constantServices } from 'src/app/griviance/models/const.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SignupService } from 'src/app/common-service/signup.service';

@Component({
  selector: 'app-edit-detail',
  templateUrl: './edit-detail.component.html',
  styleUrls: ['./edit-detail.component.css']
})
export class EditDetailComponent implements OnInit {
  @ViewChild('myInput') myInputVariable: ElementRef;
  @ViewChild('documentaryProof') documentaryProofVariable: ElementRef;
  @ViewChild('inviteedocumentaryProof') inviteedocumentaryProofVariable: ElementRef;
  @ViewChild('bioData') bioDataVariable: ElementRef;
  @ViewChild('briefBio') briefBioVariable: ElementRef;

  subscribe: Subject<any> = new Subject<any>();

  filepath: any = '/opt/ptrRegistartionFiles/';
  submitted = false;
  redirectPageCounter = 10;
  userDetails: any;
  getRegDraftDetails: any;
  registrationId: any;
  maxDate: string;
  validDate: string;
  inviteemaxDate: string;
  PermittedMaxDate: string;
  stateName = false;
  cityName = false;
  inviteeshowstateName = false;
  inviteeshowcityName = false;
  inviteestateName = false;
  inviteecityName = false;
  decryptRegistrationId: any;
  showAdd = false;
  public form: FormGroup;
  toAddressArr: any = [];
  institutionTypeList: any = [];
  i: any = 0;
  today1 = moment().format('YYYY-MM-DD');
  inviteeFileName: any = [];
  showRegistrationDetails = false;
  get f() { return this.formGroupId.controls; }
  countryList: any = [];
  stateList: any = [];
  cityList: any = [];
  allstateList: any = [];
  allcityList: any = [];
  inviteestateList: any = [];
  inviteecityList: any = [];
  inviteeallstateList: any = [];
  inviteeallcityList: any = [];
  roleName: any;
  sampleDocURL = "/PTR/SignedDoc/Self Declaration format.docx";
  statusId: any;

  constructor(public tostar: ToastrService, public router: Router, private formBuilder: FormBuilder, public route: ActivatedRoute,
    public helper: HelperService, public signin: PtrService, private spinner: NgxSpinnerService,
    public ced: encryptionService, private toastr: ToastrService, public serverURL: ServerURLService,
    public ecConst: constantServices, public ecservice: ExcutiveService,
    public scconst: constantServices, public EncrDecr: EncrDecrService,
    private _form: FormBuilder, public usrMgtService: UsrmgtService, public signinService: SignupService) { }


  formGroupId = this.formBuilder.group({
    registrationId: [''],
    name: [''],
    userEmail: [''],
    addressLine1: [''],
    addressLine2: [''],
    countryId: [''],
    stateId: [''],
    cityId: [''],
    pinCode: [''],
    mobileNumber: [''],
    landlineNumber: [''],
    certificateRegistration: ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(15)])],
    purposeConducting: ['', [Validators.required, Validators.maxLength(1000)]],
    startDate: ['', Validators.required],
    endDate: ['', Validators.required],
    permittedStartDate: ['', Validators.required],
    permittedEndDate: ['', Validators.required],
    venueProgram: ['', Validators.required],
    completeBio: ['', Validators.required],
    documentaryProof: ['', Validators.compose([Validators.required])],
    validityRegistration: ['', Validators.required],
    // personalGainProfit: ['', Validators.required],
    // onlinePaymentInformation: ['', Validators.required],
    declarationContent: ['', Validators.required],
    // permissionGrantStatus: ['', Validators.required],
    // grantedRefundMade: ['', Validators.required],
    // grantedRefundParticulars: ['', Validators.required],
    stateName: ['', Validators.compose([Validators.required])],
    cityName: ['', Validators.compose([Validators.required])],
    country: ['', Validators.compose([Validators.required])],
    institutionTypeId: ['', Validators.compose([Validators.required])],
    institutionTypeName: [''],
    declare: [false],
    utrNo: [''],
    paymentStatus: [''],
    paymentStatusCode: [''],
    transactionAmount: [''],
    transactionDate: [''],
    submittedDate: [''],
  });

  ngOnInit() {
    this.roleName = sessionStorage.getItem('selectedRole-usec');

    this.route.params.subscribe(params => {
      if (params.id != null && params.id != undefined && params.id != 0) {
        this.decryptRegistrationId = params.id;
        this.registrationId = this.EncrDecr.get(this.serverURL.secretKey, this.decryptRegistrationId)
      }
    });

    this.signin.institutionTypeList().subscribe((result: any) => {
      this.institutionTypeList = result;
    }, error => {
        console.log(error);
        this.helper.errorMessage(error);
    });

    if (this.roleName === 'PTR' || this.roleName === 'College Principal') {
      this.getAllCountry();
      this.getAllCities();
      this.getAllStates();
      this.getPtrDetails();
    } else {
      this.signinService.deleteOauthToken();
    }
  }

  getAllCountry() {
    this.signin.countryList().subscribe((result: any) => {
      this.countryList = result;
    }, error => {
      console.log(error);
    });
  }

  getAllCities() {
    this.signin.cityList().subscribe((result: any) => {
      this.allcityList = result;
      this.inviteeallcityList = result;

    }, error => {
      console.log(error);
    });
  }

  getAllStates() {
    this.signin.stateList().subscribe((result: any) => {
      this.allstateList = result;
      this.inviteeallstateList = result;
    }, error => {
      console.log(error);
    });
  }

  getPtrDetails() {
    if (this.registrationId != null && this.registrationId != undefined && this.registrationId != 0) {
      //For User login Editable mode
      this.spinner.show();
      this.signin.userDetailsById(this.registrationId).subscribe((result: any) => {
        this.spinner.hide();
        this.userDetails = result;
        if (result?.statusId != null && result?.statusId != undefined && result?.statusId != "") {
          if (result?.statusId === 9) {
            this.statusId = 'SFC';
          } else {
            this.statusId = 'SAD';
          }
        } else {
          this.statusId = 'SAD';
        }

        if (this.userDetails.institutionTypeId === 1 || this.userDetails.institutionTypeId === "1" ||
          this.userDetails.institutionTypeId === 3 || this.userDetails.institutionTypeId === "3" ||
          this.userDetails.institutionTypeId === 6 || this.userDetails.institutionTypeId === "6" ||
          this.userDetails.institutionTypeId === 7 || this.userDetails.institutionTypeId === "7"
        ) {
          this.showRegistrationDetails = false;
          this.formGroupId.controls.certificateRegistration.clearValidators();
          this.formGroupId.controls['certificateRegistration'].updateValueAndValidity();
          this.formGroupId.controls.documentaryProof.clearValidators();
          this.formGroupId.controls['documentaryProof'].updateValueAndValidity();
        } else {
          this.showRegistrationDetails = true;
          this.formGroupId.controls.certificateRegistration.setValidators(Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(15)]));
          this.formGroupId.controls.documentaryProof.setValidators(Validators.compose([Validators.required]));
        }



        if (this.userDetails.inviteeList != null && this.userDetails.inviteeList.length > 0) {
          this.initializeForm();
          this.formdata(this.userDetails);

          for (let i = 0; i < this.userDetails.inviteeList.length; i++) {
            this.addRowDetails('ToAddress', i, this.userDetails.inviteeList[i]);
          }
        } else {
          this.initializeForm();
          this.addRow('ToAddress', 0);
          this.formdata(this.userDetails);


          let x = this.form.get('itemRows')['controls'];
          for (let j = 0; j < x.length; j++) {
            x[j].controls.inviteename.setValidators(Validators.compose([Validators.required, Validators.maxLength(100)]));
            x[j].controls.inviteeemail.setValidators(Validators.compose([Validators.required, Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]));
            x[j].controls.inviteeaddressLine1.setValidators(Validators.compose([Validators.required, Validators.maxLength(255)]));
            // x[j].controls.inviteeaddressLine2.setValidators(Validators.compose([Validators.required, Validators.maxLength(255)]));
            x[j].controls.inviteecountryId.setValidators(Validators.compose([Validators.required]));
            x[j].controls.inviteestateId.setValidators(Validators.compose([Validators.required]));
            x[j].controls.inviteecityId.setValidators(Validators.compose([Validators.required]));
            x[j].controls.inviteepinCode.setValidators(Validators.compose([Validators.required]));
            x[j].controls.inviteemobileNumber.setValidators(Validators.compose([Validators.required, Validators.minLength(10)]));
            x[j].controls.bioData.setValidators(Validators.compose([Validators.required]));


            x[j].controls.inviteecertificateRegistration.setValidators(Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(15)]));
            x[j].controls.inviteedocumentaryProof.setValidators(Validators.compose([Validators.required]));

            x[j].controls.briefBio.setValidators(Validators.compose([Validators.required]));

            x[j].controls.councilName.setValidators(Validators.compose([Validators.required]));
            x[j].controls.validUpto.setValidators(Validators.compose([Validators.required]));
            this.getCities(j);
          }
        }
        this.selecetdDate(this.userDetails?.startDate, true);
        this.selectedValidDate(this.userDetails?.endDate, true);

      }, error => {
        this.spinner.hide();
        console.log(error);
      });
    } else if (this.roleName === 'College Principal') {

      this.signin.userDetailsByCollege().subscribe((result: any) => {
        this.userDetails = result;
        if (result?.statusId != null && result?.statusId != undefined && result?.statusId != "") {
          if (result?.statusId === 9) {
            this.statusId = 'SFC';
          } else {
            this.statusId = 'SAD';
          }
        } else {
          this.statusId = 'SAD';
        }

        if (this.userDetails.institutionTypeId === 1 || this.userDetails.institutionTypeId === "1" ||
          this.userDetails.institutionTypeId === 3 || this.userDetails.institutionTypeId === "3" ||
          this.userDetails.institutionTypeId === 6 || this.userDetails.institutionTypeId === "6" ||
          this.userDetails.institutionTypeId === 7 || this.userDetails.institutionTypeId === "7"
        ) {
          this.showRegistrationDetails = false;
          this.formGroupId.controls.certificateRegistration.clearValidators();
          this.formGroupId.controls['certificateRegistration'].updateValueAndValidity();
          this.formGroupId.controls.documentaryProof.clearValidators();
          this.formGroupId.controls['documentaryProof'].updateValueAndValidity();
          this.formGroupId.controls.countryId.clearValidators();
          this.formGroupId.controls['countryId'].updateValueAndValidity();
          this.formGroupId.controls.stateId.clearValidators();
          this.formGroupId.controls['stateId'].updateValueAndValidity();
          this.formGroupId.controls.cityId.clearValidators();
          this.formGroupId.controls['cityId'].updateValueAndValidity();
        } else {
          this.showRegistrationDetails = true;
          this.formGroupId.controls.certificateRegistration.setValidators(Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(15)]));
          this.formGroupId.controls.documentaryProof.setValidators(Validators.compose([Validators.required]));
          this.formGroupId.controls.countryId.setValidators(Validators.compose([Validators.required]));
          this.formGroupId.controls.stateId.setValidators(Validators.compose([Validators.required]));
          this.formGroupId.controls.cityId.setValidators(Validators.compose([Validators.required]));
        }
        this.initializeForm();
        this.addRow('ToAddress', 0);
        this.formdata(this.userDetails);
        this.selecetdDate(this.userDetails?.startDate, true);
        this.selectedValidDate(this.userDetails?.endDate, true);

      }, error => {
        console.log(error);
      });

    } else {

      this.signin.userDetailsByEmail().subscribe((result: any) => {
        this.userDetails = result;
        if (result?.statusId != null && result?.statusId != undefined && result?.statusId != "") {
          if (result?.statusId === 9) {
            this.statusId = 'SFC';
          } else {
            this.statusId = 'SAD';
          }
        } else {
          this.statusId = 'SAD';
        }
        if (this.userDetails.institutionTypeId === 1 || this.userDetails.institutionTypeId === "1" ||
          this.userDetails.institutionTypeId === 3 || this.userDetails.institutionTypeId === "3" ||
          this.userDetails.institutionTypeId === 6 || this.userDetails.institutionTypeId === "6" ||
          this.userDetails.institutionTypeId === 7 || this.userDetails.institutionTypeId === "7"
        ) {
          this.showRegistrationDetails = false;
          this.formGroupId.controls.certificateRegistration.clearValidators();
          this.formGroupId.controls['certificateRegistration'].updateValueAndValidity();
          this.formGroupId.controls.documentaryProof.clearValidators();
          this.formGroupId.controls['documentaryProof'].updateValueAndValidity();
        } else {
          this.showRegistrationDetails = true;
          this.formGroupId.controls.certificateRegistration.setValidators(Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(15)]));
          this.formGroupId.controls.documentaryProof.setValidators(Validators.compose([Validators.required]));
        }
        this.initializeForm();
        this.addRow('ToAddress', 0);
        this.formdata(this.userDetails);
        this.selecetdDate(this.userDetails?.startDate, true);
        this.selectedValidDate(this.userDetails?.endDate, true);
      }, error => {
        console.log(error);
      });
    }

  }

  // APPLICANT
  findState() {
    if (this.formGroupId.value.countryId != null && this.formGroupId.value.countryId != undefined && this.formGroupId.value.countryId != "") {
      let countryId = this.formGroupId.value.countryId;
      if (countryId === "1" || countryId === 1) {
        this.stateName = false;
        this.cityName = false;
        //DISABLE VALIDATION FOR TEXT BY SUGAND
        this.formGroupId.controls.stateName.clearValidators();
        this.formGroupId.controls['stateName'].updateValueAndValidity();
        this.formGroupId.controls.cityName.clearValidators();
        this.formGroupId.controls['cityName'].updateValueAndValidity();

        this.formGroupId.controls.stateId.setValidators(Validators.required);
        this.formGroupId.controls.cityId.setValidators(Validators.required);


        this.stateList = this.allstateList.filter(function (item) {
          return item.country.countryId == parseInt(countryId);
        });

      } else {
        this.stateName = true;
        this.cityName = true;
        //DISABLED 
        this.formGroupId.controls.stateId.clearValidators();
        this.formGroupId.controls['stateId'].updateValueAndValidity();
        this.formGroupId.controls.cityId.clearValidators();
        this.formGroupId.controls['cityId'].updateValueAndValidity();

        this.formGroupId.controls.stateName.setValidators(Validators.required);
        this.formGroupId.controls.cityName.setValidators(Validators.required);
      }
    }
  }


  //INVITEE
  findInviteeState(i) {
    const x = this.form.get('itemRows')['controls'];

    let countryId = x[i].controls.inviteecountryId.value;

    if (countryId === "1" || countryId === 1) {
      x[i].inviteeshowstateName = true;
      x[i].inviteeshowcityName = true;
      this.inviteestateName = true;
      this.inviteecityName = true;

      //DISABLE VALIDATION FOR TEXT BY SUGAND
      x[i].controls.inviteestateName.clearValidators();
      x[i].controls['inviteestateName'].updateValueAndValidity();
      x[i].controls.inviteecityName.clearValidators();
      x[i].controls['inviteecityName'].updateValueAndValidity();

      x[i].controls.inviteestateId.setValidators(Validators.required);
      x[i].controls.inviteecityId.setValidators(Validators.required);


      this.inviteestateList = this.inviteeallstateList.filter(function (item) {
        return item.country.countryId == parseInt(countryId);
      });

    } else {
      x[i].inviteeshowstateName = false;
      x[i].inviteeshowcityName = false;
      this.inviteestateName = false;
      this.inviteecityName = false;
      //DISABLED 
      x[i].controls.inviteestateId.clearValidators();
      x[i].controls['inviteestateId'].updateValueAndValidity();
      x[i].controls.inviteecityId.clearValidators();
      x[i].controls['inviteecityId'].updateValueAndValidity();

      x[i].controls.inviteestateName.setValidators(Validators.required);
      x[i].controls.inviteecityName.setValidators(Validators.required);
    }
  }
  findCity() {
    if (this.formGroupId.value.stateId != null && this.formGroupId.value.stateId != undefined && this.formGroupId.value.stateId != "") {
      let stateId = this.formGroupId.value.stateId;
      this.cityList = this.allcityList.filter(function (item) {
        if (item.state !== null && item.state.stateId !== "") {
          return item.state.stateId == parseInt(stateId);
        }
      });
    }
  }

  // getCities
  getCities(groupName) {
    let stateId = this.formGroupId.value.stateId;
    if (stateId !== null)
      this.usrMgtService.getAllCities(stateId).pipe(takeUntil(this.subscribe)).subscribe(res => {
        this.allcityList[groupName] = res;
        this.cityList = this.allcityList[groupName].filter(function (item) {
          if (item.state !== null && item.state.stateId !== "") {
            return item.state.stateId == parseInt(stateId);
          }
        });
      }, error => {
        this.spinner.hide();
        console.log(error);
      });
  }


  findInviteeCity(i) {
    const x = this.form.get('itemRows')['controls'];
    let stateId = x[i].controls.inviteestateId.value;
    this.inviteecityList = this.inviteeallcityList.filter(function (item) {
      if (item.state !== null && item.state.stateId !== "") {
        return item.state.stateId == parseInt(stateId);
      }
    });
    x[i].controls.inviteecityList.value = this.inviteecityList;
  }
  findInviteeCityNew(i) {
    const x = this.form.get('itemRows')['controls'];
    let stateId = x[i].controls.inviteestateId.value;
    if (stateId !== null)
      this.usrMgtService.getAllCities(stateId).pipe(takeUntil(this.subscribe)).subscribe(res => {
        this.inviteecityList = res;
        x[i].controls.inviteecityList.value = this.inviteecityList;
      }, error => {
        this.spinner.hide();
        console.log(error);
      });
  }

  selecetdDate(data: any, startDate: any) {
    if(data != null) {
      if(!startDate) {
        this.formGroupId.controls.endDate.setValue("");
      }
    this.maxDate = moment(data).add(0, 'days').format('YYYY-MM-DD');
    }
  }

  selectedValidDate(data: any, validUpto: boolean) {
    if(data != null) {
      if(!validUpto) {
        for (const iterator of this.form.get('itemRows')['controls']) {
          iterator.controls.validUpto.setValue("");
        }
      }
      this.validDate = moment(data).add(0, 'days').format('YYYY-MM-DD');
    }
  }

  selecetdInviteeDate(data: any, i) {
    let x = this.form.get('itemRows')['controls'];
    x[i].controls.workingPeriodTo.setValue("");
    this.inviteemaxDate = moment(data).add(0, 'days').format('YYYY-MM-DD');
  }
  selecetdPermittedDate(data: any) {
    this.formGroupId.controls.permittedEndDate.setValue("");
    this.PermittedMaxDate = moment(data).add(0, 'days').format('YYYY-MM-DD');
  }
  formdata(result) {
    if (this.registrationId != null && this.registrationId != undefined && this.registrationId != 0) {
      this.formGroupId = this.formBuilder.group({
        registrationId: [result.registrationId],
        name: [result.name],
        userEmail: [result.userEmail],
        addressLine1: [result.addressLine1],
        addressLine2: [result.addressLine2],
        countryId: [result.countryId],
        stateId: [result.stateId],
        cityId: [result.cityId],
        pinCode: [result.pinCode],
        mobileNumber: [result.mobileNumber],
        certificateRegistration: [result.certificateRegistration, Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(15)])],
        purposeConducting: [result.purposeConducting, [Validators.required, Validators.maxLength(1000)]],
        startDate: [result.startDate, Validators.required],
        endDate: [result.endDate, Validators.required],
        venueProgram: [result.venueProgram, Validators.required],
        documentaryProof: [result.documentaryProof, Validators.compose([Validators.required])],
        stateName: [result.stateName, Validators.compose([Validators.required])],
        cityName: [result.cityName, Validators.compose([Validators.required])],
        country: [result.country, Validators.compose([Validators.required])],
        institutionTypeId: [result.institutionTypeId],
        institutionTypeName: [result.institutionTypeName],
        landlineNumber: [result.landlineNumber],
        applicationId: [result.applicationId],
        utrNo: [result.utrNo],
        paymentStatus: [result.paymentStatus],
        paymentStatusCode: [result.paymentStatusCode],
        transactionAmount: [result.transactionAmount],
        transactionDate: [result.transactionDate],        
        submittedDate: [result.submittedDate],
      });
    } else {
      this.formGroupId = this.formBuilder.group({
        registrationId: [''],
        name: [result.name],
        userEmail: [result.userEmail],
        addressLine1: [result.addressLine1],
        addressLine2: [result.addressLine2],
        countryId: [result.countryId],
        stateId: [result.stateId],
        cityId: [result.cityId],
        pinCode: [result.pinCode],
        mobileNumber: [result.mobileNumber],
        certificateRegistration: ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(15)])],
        purposeConducting: ['', [Validators.required, Validators.maxLength(1000)]],
        startDate: ['', Validators.required],
        endDate: ['', Validators.required],
        venueProgram: ['', Validators.required],
        documentaryProof: ['', Validators.compose([Validators.required])],
        stateName: [result.stateName, Validators.compose([Validators.required])],
        cityName: [result.cityName, Validators.compose([Validators.required])],
        country: [result.country, Validators.compose([Validators.required])],
        institutionTypeId: [result.institutionTypeId],
        institutionTypeName: [result.institutionTypeName],
        landlineNumber: [''],
        applicationId: [''],
        utrNo: [''],
        paymentStatus: [''],
        paymentStatusCode: [''],
        transactionAmount: [''],
        transactionDate: [''],
        submittedDate: ['']
      });
    }

    
    this.findState();
  }

  //Submit 
  onSubmit(status) {
    this.submitted = true;
    if (this.userDetails.institutionTypeId === 1 || this.userDetails.institutionTypeId === "1" ||
      this.userDetails.institutionTypeId === 3 || this.userDetails.institutionTypeId === "3" ||
      this.userDetails.institutionTypeId === 6 || this.userDetails.institutionTypeId === "6" ||
      this.userDetails.institutionTypeId === 7 || this.userDetails.institutionTypeId === "7") {
      this.showRegistrationDetails = false;
      this.formGroupId.controls.certificateRegistration.clearValidators();
      this.formGroupId.controls['certificateRegistration'].updateValueAndValidity();
      this.formGroupId.controls.documentaryProof.clearValidators();
      this.formGroupId.controls['documentaryProof'].updateValueAndValidity();
      this.formGroupId.controls.countryId.clearValidators();
      this.formGroupId.controls['countryId'].updateValueAndValidity();
      this.formGroupId.controls.stateId.clearValidators();
      this.formGroupId.controls['stateId'].updateValueAndValidity();
      this.formGroupId.controls.cityId.clearValidators();
      this.formGroupId.controls['cityId'].updateValueAndValidity();
      this.formGroupId.controls.registrationId.clearValidators();
      this.formGroupId.controls['registrationId'].updateValueAndValidity();
    } else {
      this.showRegistrationDetails = true;
      this.formGroupId.controls.certificateRegistration.setValidators(Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(15)]));
      this.formGroupId.controls.documentaryProof.setValidators(Validators.compose([Validators.required]));
      this.formGroupId.controls.countryId.setValidators(Validators.compose([Validators.required]));
      this.formGroupId.controls.stateId.setValidators(Validators.compose([Validators.required]));
      this.formGroupId.controls.cityId.setValidators(Validators.compose([Validators.required]));
      this.formGroupId.controls.registrationId.setValidators(Validators.compose([Validators.required]));
    }


    if (this.formGroupId.invalid || this.form.invalid) {
      return;
    }
    this.onDraftSubmit(status);
  }

  //Save As Draft 
  onDraftSubmit(status) {
    const allArray = [];
    this.formGroupId.value.permittedStartDate = this.formGroupId.value.permittedStartDate;
    this.formGroupId.value.permittedEndDate = this.formGroupId.value.permittedEndDate;
    this.formGroupId.value.endDate = this.formGroupId.value.endDate;
    this.formGroupId.value.startDate = this.formGroupId.value.startDate;
    // this.formGroupId.value.applicationStatus = this.statusId;
    this.formGroupId.value.status = this.statusId;
    this.formGroupId.value.roleName = sessionStorage.getItem('selectedRole-usec');

    this.formGroupId.value.institutionTypeId = parseInt(this.formGroupId.value.institutionTypeId);


    if (this.formGroupId.value.documentaryProof != null && this.formGroupId.value.documentaryProof != undefined && this.formGroupId.value.documentaryProof != "") {
      if (this.formGroupId.value.documentaryProof.includes(" ")) {
        this.formGroupId.value.documentaryProof = this.formGroupId.value.documentaryProof.replaceAll(" ", "_");
      }
    }else{
      this.formGroupId.value.documentaryProof = null;
    }

    for (const iterator of this.form.getRawValue().itemRows) {

    if (iterator.briefBio != null && iterator.briefBio != undefined) {
      if (iterator.briefBio.includes(" ")) {
        iterator.briefBio = iterator.briefBio.replaceAll(" ", "_");
      }
    }else{
      iterator.briefBio = null;
    }

    if (iterator.bioData != null && iterator.bioData != undefined) {
      if (iterator.bioData.includes(" ")) {
        iterator.bioData = iterator.bioData.replaceAll(" ", "_");
      }
    }else{
      iterator.bioData = null;
    }

    if (iterator.inviteedocumentaryProof != null && iterator.inviteedocumentaryProof != undefined) {
      if (iterator.inviteedocumentaryProof.includes(" ")) {
        iterator.inviteedocumentaryProof = iterator.inviteedocumentaryProof.replaceAll(" ", "_");
      }
    }else{
      iterator.inviteedocumentaryProof = null;
    }

      const addobj = {
        inviteeName: iterator.inviteename,
        userEmail: iterator.inviteeemail,
        mobileNumber: iterator.inviteemobileNumber,
        addressLine1: iterator.inviteeaddressLine1,
        addressLine2: iterator.inviteeaddressLine2,
        cityId: iterator.inviteecityId,
        stateId: iterator.inviteestateId,
        pinCode: iterator.inviteepinCode,
        countryId: iterator.inviteecountryId,
        bioData: iterator.bioData,
        inviteecertificateRegistration: iterator.inviteecertificateRegistration,
        inviteedocumentaryProof: iterator.inviteedocumentaryProof,
        councilName: iterator.councilName,
        validUpto: iterator.validUpto,
        country: iterator.inviteecountryName,
        stateName: iterator.inviteestateName,
        cityName: iterator.inviteecityName,
        briefBio: iterator.briefBio
      }

      allArray.push(addobj);

    }

    this.formGroupId.value.inviteeList = allArray;
    this.formGroupId.value.whoAssignedUserId = sessionStorage.getItem('userId-usec');

    this.spinner.show();
    this.signin.updateRegistration(this.formGroupId.value).subscribe((data: any) => {
      this.spinner.hide();
      if (data?.response?.respcode == '200') {
        if (status == 'SAVEASDRAFT') {
          this.tostar.success('Save As Draft Successfully', 'Success', {
            timeOut: 5000
          });
          this.uploadfiles(data.registrationId);
          this.router.navigate(['/main/internal/ptr/dashboard/0']);
        } else if (status == 'SUBMIT') {
          this.tostar.success('PTR Details Updated Successfully', 'Success', {
            timeOut: 5000
          });
          this.uploadfiles(data.registrationId);
          if (this.statusId == 'SFC') {
            this.router.navigate(['/main/internal/ptr/dashboard/0']);
          } else {
            var encrypted = this.EncrDecr.set(this.serverURL.secretKey, data.registrationId);
            this.router.navigate(['/main/internal/ptr/paymentReceipt/', encrypted]);
          }
        }
      } else if (data?.response?.respcode == '500') {
        this.displayErrorMsg('error', data.response.message);
      } else {
        this.displayErrorMsg('error', 'Update is Failed!!');
      }
    }, error => {
      this.spinner.hide();
      error.status = error.status == 0 ? 500 : error.status
      console.log(error);

    });

  }

  private displayErrorMsg(type: string, msg: string) {
    if (type == 'error') {
      this.toastr.error(msg, 'Error', {
        timeOut: 3000
      });
    }
  }
  uploadfiles(regId: any) {
    this.signin.uploadFile(this.files, regId).subscribe((data: any) => {
      if (data?.response?.respcode == '200') {

      } else if (data?.response?.respcode == '500') {

      }
    }, error => {
      console.log(error);
    });
  }

  files = [];
  onSelectFile(event, filename) {
    let file = event.target.files[0];
    if (event.target.files && file) {
      if (file.type === 'application/pdf') {
        if (file.size > 204800) {
          this.tostar.warning('Please upload valid document with less than 200kb');
          return;
        }
        const filesAmount = event.target.files;
        this.files.push(filesAmount[0]);
        this.formGroupId.controls[filename].setValue(filesAmount[0].name);
        //let email = sessionStorage.getItem('email-Id');
        //this.formGroupId.controls[filename].setValue("/" + "PTR/" + email + "/" + filesAmount[0].name);
      } else {
        if (filename === 'documentaryProof') {
          this.documentaryProofVariable.nativeElement.value = "";
        } else {
          this.myInputVariable.nativeElement.value = "";
        }
        this.tostar.warning("PDf file only accept", 'Error', {
          timeOut: 2000
        });
      }
    } else {
      this.formGroupId.controls[filename].setValue(null);
    }
  }

  onSelectInviteeFile(event, filename, i) {
    let x = this.form.get('itemRows')['controls'];
    let file = event.target.files[0];
    if (event.target.files && file) {
      if (file.type === 'application/pdf') {
        if (file.size > 204800) {
          this.tostar.warning('Please upload valid document with less than 200kb');
          return;
        }
        const filesAmount = event.target.files;
        this.files.push(filesAmount[0]);
        x[i].controls[filename].setValue(filesAmount[0].name);

        // let email = sessionStorage.getItem('email-Id');
        // x[i].controls[filename].setValue("/" + "PTR/" + email + "/" + filesAmount[0].name);
        //this.inviteeFileName.push("/"+email+"/"+filesAmount[0].name);
      } else {
        if (filename === "inviteedocumentaryProof") {
          this.inviteedocumentaryProofVariable.nativeElement.value = "";
        } else if (filename === "bioData") {
          this.bioDataVariable.nativeElement.value = "";
        } else if (filename === "briefBio") {
          this.briefBioVariable.nativeElement.value = "";
        }
        this.tostar.warning("PDf file only accept", 'Error', {
          timeOut: 2000
        });
      }

    } else {
      x[i].controls[filename].setValue(null);
    }
  }
  download(type) {
    let filepath = this.formGroupId.value[type];
    window.open(`${this.serverURL.ptrDocument}` + filepath)
  }
  downloadFile(blobdata, filepath) {
    const downloadLink = document.createElement("a");
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.setAttribute("href", window.URL.createObjectURL(filepath));
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  private convertStringToBoolean(value) {
    return (value == undefined || value == null || value == "") ? false : true
  }

  initializeForm() {
    this.form = this._form.group({
      itemRows: this._form.array([]),
    });
  }

  itemRows() {
    return this._form.group({
      inviteeId: [],
      inviteename: ['', [Validators.required, Validators.maxLength(100)]],
      inviteeemail: ['', [Validators.required, Validators.compose([Validators.required, Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)])]],
      inviteeaddressLine1: ['', [Validators.required, Validators.maxLength(300)]],
      inviteeaddressLine2: [''],
      inviteecountryId: ['', Validators.required],
      inviteestateId: ['', Validators.required],
      inviteecityId: ['', Validators.required],
      inviteestateName: ['', Validators.required],
      inviteecityName: ['', Validators.required],
      inviteepinCode: ['', [Validators.required]],
      inviteemobileNumber: ['', Validators.compose([Validators.required, Validators.minLength(10)])],
      bioData: ['', Validators.required],
      inviteecertificateRegistration: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(15)]],
      inviteedocumentaryProof: ['', Validators.required],
      briefBio: ['', Validators.required],
      councilName: ['', Validators.required],
      validUpto: ['', Validators.required],
      inviteecityList: [],
      agree: [false],
      declare: [false]
    });
  }

  public addRow(address: any, i) {

    const control = <FormArray>this.form.controls['itemRows'];

    // control.push(this.itemRows());
    this.toAddressArr = this.form.get('itemRows') as FormArray;

    this.toAddressArr.push(this.itemRows());


    let x = this.form.get('itemRows')['controls'];
    x[i].controls.inviteename.setValidators(Validators.compose([Validators.required, Validators.maxLength(100)]));
    x[i].controls.inviteeemail.setValidators(Validators.compose([Validators.required, Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]));
    x[i].controls.inviteeaddressLine1.setValidators(Validators.compose([Validators.required, Validators.maxLength(255)]));
    //x[i].controls.inviteeaddressLine2.setValidators(Validators.compose([Validators.required, Validators.maxLength(255)]));
    x[i].controls.inviteecountryId.setValidators(Validators.compose([Validators.required]));
    x[i].controls.inviteestateId.setValidators(Validators.compose([Validators.required]));
    x[i].controls.inviteecityId.setValidators(Validators.compose([Validators.required]));
    x[i].controls.inviteepinCode.setValidators(Validators.compose([Validators.required]));
    x[i].controls.inviteemobileNumber.setValidators(Validators.compose([Validators.required, Validators.minLength(10)]));
    x[i].controls.bioData.setValidators(Validators.compose([Validators.required]));

    x[i].controls.inviteecertificateRegistration.setValidators(Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(15)]));
    x[i].controls.inviteedocumentaryProof.setValidators(Validators.compose([Validators.required]));

    x[i].controls.briefBio.setValidators(Validators.compose([Validators.required]));
    x[i].controls.councilName.setValidators(Validators.compose([Validators.required]));
    x[i].controls.validUpto.setValidators(Validators.compose([Validators.required]));
  }

  public addRowDetails(address: any, i, iterator) {

    const control = <FormArray>this.form.controls['itemRows'];
    this.toAddressArr = this.form.get('itemRows') as FormArray;
    this.toAddressArr.push(this.itemRows());

    let x = this.form.get('itemRows')['controls'];
    x[i].controls.inviteename.setValue(iterator.inviteeName);
    x[i].controls.inviteeemail.setValue(iterator.userEmail);
    x[i].controls.inviteeaddressLine1.setValue(iterator.addressLine1);
    x[i].controls.inviteeaddressLine2.setValue(iterator.addressLine2);
    x[i].controls.inviteecountryId.setValue(iterator.countryId);
    if (x[i].controls.inviteecountryId.value === 1 || x[i].controls.inviteecountryId.value === '1') {
      this.findInviteeState(i);
      x[i].controls.inviteestateId.setValue(iterator.stateId);
      this.findInviteeCityNew(i);
      x[i].controls.inviteecityId.setValue(iterator.cityId);
      x[i].inviteeshowstateName = true;
      x[i].inviteeshowcityName = true;
      x[i].controls.inviteestateId.setValidators(Validators.compose([Validators.required]));
      x[i].controls['inviteestateId'].updateValueAndValidity();
      x[i].controls.inviteecityId.setValidators(Validators.compose([Validators.required]));
      x[i].controls['inviteecityId'].updateValueAndValidity();

      x[i].controls.inviteestateName.clearValidators();
      x[i].controls['inviteestateName'].updateValueAndValidity();
      x[i].controls.inviteecityName.clearValidators();
      x[i].controls['inviteecityName'].updateValueAndValidity();
    } else {
      x[i].controls.inviteestateName.setValue(iterator.stateName);
      x[i].controls.inviteecityName.setValue(iterator.cityName);
      x[i].inviteeshowstateName = false;
      x[i].inviteeshowcityName = false;

      x[i].controls.inviteestateName.setValidators(Validators.compose([Validators.required]));
      x[i].controls['inviteestateName'].updateValueAndValidity();
      x[i].controls.inviteecityName.setValidators(Validators.compose([Validators.required]));
      x[i].controls['inviteecityName'].updateValueAndValidity();

      x[i].controls.inviteestateId.clearValidators();
      x[i].controls['inviteestateId'].updateValueAndValidity();
      x[i].controls.inviteecityId.clearValidators();
      x[i].controls['inviteecityId'].updateValueAndValidity();
    }
    x[i].controls.inviteepinCode.setValue(iterator.pinCode);
    x[i].controls.inviteemobileNumber.setValue(iterator.mobileNumber);
    x[i].controls.bioData.setValue(iterator.bioData);

    x[i].controls.inviteecertificateRegistration.setValue(iterator.inviteecertificateRegistration);
    x[i].controls.inviteedocumentaryProof.setValue(iterator.inviteedocumentaryProof);

    x[i].controls.briefBio.setValue(iterator.briefBio);
    x[i].controls.councilName.setValue(iterator.councilName);
    x[i].controls.inviteeId.setValue(iterator.inviteeId);
    x[i].controls.validUpto.setValue(iterator.validUpto);
  }

  removeRows(j) {
    const control = <FormArray>this.form.controls['itemRows'];
    control.removeAt(j);
  }

  keyPresspincode(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  keyPress(event: any) {
    const pattern = /^[^-\s][0-9 ]*$/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  checkdeclaration() {
    const x = this.form.get('itemRows')['controls'];

    for (let j = 0; j < x.length; j++) {
      let agree = x[j].controls.agree.value;
      let declare = x[j].controls.declare.value;

      if (agree === true && declare === true) {
        this.showAdd = true;
      } else {
        this.showAdd = false;
      }

    }

  }

  viewDocuments(filePath: any, fileName: any) {
    this.usrMgtService.getRandomKeyGeneratorForViewDocument().subscribe((data: any) => {
      const randomkeyKey = this.ced.decryptAesformString(data.randamKey, this.serverURL.secretKey);
      this.viewDocumentsAfterEncryptedfilePath(this.ced.encryptAesToString(filePath, randomkeyKey).toString(), fileName);
    }, error => {
      console.log(error);
    });
  }

  viewDocumentsAfterEncryptedfilePath(filePath: any, fileName: any) {
    this.spinner.show();
    this.usrMgtService.ViewDocument(filePath).pipe().subscribe((result: any) => {
      this.spinner.hide();
      var blob = result;
      var fileURL = URL.createObjectURL(blob);
      if (fileName.split('.').pop().toLowerCase() === 'pdf') {
        window.open(fileURL);
      } else {
        var a = document.createElement("a");
        a.href = fileURL;
        a.target = '_blank';
        a.download = fileName;
        a.click();
      }
    }, error => {
      this.spinner.hide();
      console.log(error);
    });
  }

  back() {
    this.router.navigate(['/main/internal/ptr/dashboard/0']);
    sessionStorage.setItem("back", "back");
  }
}
